/** Aligns with library filters and backend `LIBRARY_TAGS` / `coerceJournalLibraryTag`. */
export const JOURNAL_LIBRARY_TAGS = [
  "Health",
  "Finance",
  "Self-care",
  "Self-growth",
  "Tech",
  "Other",
] as const;

export type JournalLibraryTag = (typeof JOURNAL_LIBRARY_TAGS)[number];

const LEGACY_TO_LIBRARY: Record<string, JournalLibraryTag> = {
  Focus: "Tech",
  Reset: "Self-care",
  Clarity: "Self-growth",
  Growth: "Self-growth",
  Energy: "Health",
  Momentum: "Other",
  Presence: "Self-care",
  Mindset: "Self-growth",
  Community: "Other",
};

/** Normalize stored/API tags for colors and UI (handles cached or legacy rows). */
export function coerceJournalTagForDisplay(raw: string | null | undefined): JournalLibraryTag {
  const t = (raw ?? "").trim();
  if ((JOURNAL_LIBRARY_TAGS as readonly string[]).includes(t)) {
    return t as JournalLibraryTag;
  }
  return LEGACY_TO_LIBRARY[t] ?? "Other";
}
